// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import { Database } from '@/types/supabase';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const SUPABASE_URL = "https://cktezoaqfyvsgbupycyz.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNrdGV6b2FxZnl2c2didXB5Y3l6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5NDkwNjYsImV4cCI6MjA4NzUyNTA2Nn0.2_g7SYmZe-A2uLTQZLc6HPl98FAwUhRipTAunskzPRs";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);
